import { Injectable } from '@angular/core';
import { SimpleMQ } from 'ng2-simple-mq';
import { CommonService } from './common.service';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/Rx';
import * as _ from 'lodash';

@Injectable()
export class ContribuentiService {
	private idFirstAnagrafica: any = null;

	private anagrafica: any[] = [];
	private _anagraficaSource = new BehaviorSubject<any[]>(this.anagrafica);
	public anagrafica$ = this._anagraficaSource.asObservable();

	private associati: any[] = [];
	private _associatiSource = new BehaviorSubject<any[]>([]);
	public associati$ = this._associatiSource.asObservable();

	/*private anagraficaRel: any[] = [];
	private _anagraficaRelSource = new BehaviorSubject<any[]>([]);
	public anagraficaRel$ = this._anagraficaRelSource.asObservable();
	*/

	constructor(private commonService: CommonService, private smq: SimpleMQ) {
		console.log("SRV|CONTRIBUENTI - ALIVE!");
		this.smq.subscribe('contribuenti', e => this.receiveMsg(e));
	}

	receiveMsg(m) {
		console.log('SRV|CONTRIBUENTI - receiveMsg:', m);
		if(m){
			let msgSender = m.sender;
			let msgType = m.type;
			let msgKey = m.key;
			let msgValue = m.value;
			switch(msgType){
				case 'risposta':
					switch(msgKey){
						case 'comuneId':
							//this.comuneId = msgValue;
							break;
						default:
							console.log('SRV|CONTRIBUENTI - receiveMsg: class', this);
					}
					break;
				default:
			}
		}
	}

	sendMsg(name: string, type: any, key: any, value: any = null) {
		// Publish to queue name
		let m = {
			sender: 'contribuenti',
			type: type,
			key: key,
			value: value,
		};
		console.log('SRV|CONTRIBUENTI - sendMsg:', m);
		this.smq.publish(name, m);
	}

	// Anagrafica
	getAnagrafica(comuneId: any, localFilters:any){
		console.log("SRV|CONTRIBUENTI - ANAGRAFICA PRE:", comuneId);
		this.commonService.getDB().getElementsByQuery('anagrafica', null, localFilters, comuneId).subscribe(
			data => {
				this.anagrafica = this.commonService.readDatabaseResponse('', data) ? this.commonService.readDatabaseResponse('', data) : []
			},
			error => { console.log(error); },
			() => {
				let formatterTemp = this.commonService.getLocale();
				for(let person of this.anagrafica){
					person.indirizzo_completo = person.indirizzo +', '+ person.civico_num;
					person.societa = Boolean(Number(person.societa));
					person.in_vita = Boolean(Number(person.in_vita));
					person.aggiornamento_data_ridotta_view = formatterTemp.toLocaleDate(person.aggiornamento_data);
					person.aggiornamento_data_ridotta = formatterTemp.toInternetString(person.aggiornamento_data_ridotta_view);
				}
				this.anagrafica = this.commonService.sortArray(this.anagrafica, 'anagrafica_id');
				this.getFirstAnagrafica();
				this._anagraficaSource.next(this.anagrafica);
				console.log("SRV|CONTRIBUENTI - ANAGRAFICA:", this.anagrafica, comuneId);
			}
		);
	}

	getFirstAnagrafica(){
		let minAnagrafica = null;
		this.idFirstAnagrafica = 0;

		if(this.anagrafica){
			minAnagrafica = this.commonService.getMin(this.anagrafica, 'anagrafica_id', null);
			if(minAnagrafica){
				this.idFirstAnagrafica = minAnagrafica.anagrafica_id;
			}
		}
		console.log("SRV|CONTRIBUENTI - GETFIRSTANAGRAFICA:", this.idFirstAnagrafica);
		return this.idFirstAnagrafica;
	}

	getPersonById(anagrafica_id: any, callback: any) {
		let personFind = null;
		console.log("anagraficabyID:", anagrafica_id, this.anagrafica);
		if(anagrafica_id && this.anagrafica){
			for (let person of this.anagrafica) {
				if (person.anagrafica_id == anagrafica_id) {
					personFind = _.cloneDeep(person);
					console.log("anagrafica trovata:", anagrafica_id, personFind);
					break;
				}
			}
			callback(personFind);
		}
	}

	getAnagraficheByCf(comuneId: any, cf: any) {
		console.log("SRV|CONTRIBUENTI - getAnagraficheByCf:", comuneId);
		return this.commonService.getDB().getAnagraficheByCf(cf, comuneId);
	}

	// Associati
	getAssociati(comuneId: any, localFilters: any[]) {
		let localTable = null;
		console.log("SRV|CONTRIBUENTI - ASSOCIATI:", comuneId);

		this.commonService.getDB().getElementsByQuery("associati", localTable, localFilters, comuneId)
			.subscribe(
				data => { this.associati = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => console.log(error),
				() => {
					this._associatiSource.next(this.associati);
					console.log("SRV|CONTRIBUENTI - ASSOCIATI:", this.associati);
				}
			);
	}

	/*getAnagraficaRel(localFilters: any[]) {
		console.log("SRV|CONTRIBUENTI - ANAGRAFICA_REL:", this.comuneId);

		this.commonService.getDB().getElementsByTable("anagrafica_rel", this.comuneId)
			.subscribe(
				data => { this.anagraficaRel = this.commonService.readDatabaseResponse('',data); },
				error => { console.log(error) },
				() => {
					this._anagraficaRelSource.next(this.anagraficaRel);
					console.log("SRV|CONTRIBUENTI - ANAGRAFICA_REL:", this.anagraficaRel);
				}
			);
	}*/

	getAnagraficaRelById(id: any) {
		for (let rel of this.associati) {
			if (rel.id == id) {
				return _.cloneDeep(rel);
			}
		}
	}

	getAssociatiByPersonId(idPerson: any, callback: any) {
		let associati: any[] = [];
		if(idPerson && this.associati){
			for (let associato of this.associati) {
				//console.log("associato", associato, " idPerson:", idPerson);
				if (associato.anagrafica_id == idPerson) {
					associati.push( _.cloneDeep(associato) );
				}
			}
			console.log("SRV|CONTRIBUENTI - ASSOCIATI", associati, " idPerson:", idPerson);
			callback(associati);
		}
	}

	hasAssociatoByPersonId(idPerson: any){
		//console.log("hasAssociatoByPersonId", idPerson, this.associati);
		for (let anagraficaRel of this.associati) {
			if (anagraficaRel.associato == idPerson) {
				return false;
			}
		}
		return true;
	}
}
